import { JsonObject, JsonProperty } from 'json2typescript';

import { AttrOption } from './option';

/**
 * åç±»éç½®
 */
@JsonObject
export class Classification {
  /**
   * åç±»éç½®çId
   */
  @JsonProperty('id', Number)
  id: number = undefined;

  /**
   * æå±åºå·
   */
  @JsonProperty('index', Number)
  index: number = undefined;

  /**
   * æ¯å¦åè®¸å¤é
   */
  @JsonProperty('multiChoice', Boolean)
  multiChoice: boolean = undefined;

  /**
   * åç±»éç½®çåç§°
   */
  @JsonProperty('name', String)
  name: string = undefined;

  /**
   * åç±»éç½®æä¾çéé¡¹åè¡¨
   */
  @JsonProperty('options', [AttrOption])
  options: AttrOption[] = [];

  /**
   * todo
   */
  @JsonProperty('resId', String)
  resId: string = undefined;

  /**
   * todo
   */
  @JsonProperty('type', String)
  type: string = undefined;
}
